import { AssetSvgProps } from "../../../shared/assets"
function PlaInd037({ className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <g id="PlaInd037__Layer4_1_FILL">
                    <path
                        fill="url(#PlaInd037__Gradient_1)"
                        d="M385 206V0H0v206q195.469 16.327 385 0z"
                    />
                    <path
                        fill="#46412F"
                        d="M385 273.2v-39.5q-192.995-19.31-385 0v39.5h385z"
                    />
                </g>
                <g id="PlaInd037__Layer3_0_FILL">
                    <path d="M278.5 310.15l9.65 18.25h38.65l-13.45-18.25H278.5m20 37.95l-10.35-19.7H249.4l6.2 19.7h42.9M262.25 369l5.05 16h50.6l-8.4-16h-47.25m-18.65-58.85h34.9l-7.65-14.55H239l4.6 14.55m-71.5 37.95h40.75l-2.1-19.7H174.2l-2.1 19.7m40.75 0l2.25 20.9h47.15l-6.65-20.9h-42.75m-43 20.9l-1.75 16h48.7l-1.7-16h-45.25m38.9-58.85l2 18.25h38.65l-5.8-18.25h-34.85m-1.55-14.55h-29.45l-1.55 14.55h32.55l-1.55-14.55m0 0H239l-3.85-12.15H205.9l1.3 12.15m-27.05-22.4l-1.1 10.25h26.85l-1.1-10.25h-24.65m113.5 10.25h29.3l-9.7-10.25H286.1l7.55 10.25m-29.25 0l6.45 12.15h31.8l-9-12.15H264.4m0 0L259 273.2h-27.1l3.25 10.25h29.25M129.35 348.1l6.2-19.7H96.8l-10.35 19.7h42.9m0 0L122.7 369h47.15l2.25-20.9h-42.75m12-37.95l-5.8 18.25h38.65l2-18.25h-34.85m-97.7 37.95L28.2 369h47.25l11-20.9h-42.8m-6.9-37.95H71.6l10.7-14.55H50.5l-13.75 14.55m6.9 37.95l14.5-19.7h-38.7L.8 348.1h42.85m31.8 20.9L67 385h50.6l5.1-16H75.45m-47.25 0H0v16h16.4l11.8-16M.8 348.1H0v.85l.8-.85m35.95-37.95H1.9l-1.9 1.6v16.65h19.45l17.3-18.25m34.85 0L58.15 328.4H96.8l9.65-18.25H71.6M18.7 295.6H0v14.55h1.9l16.8-14.55m14.05-12.15L18.7 295.6h31.8L62 283.45H32.75m-29.25 0H0V286l3.5-2.55m14-10.25l-14 10.25h29.25L44.6 273.2H17.5m128.45 22.4H114.1l-7.65 14.55h34.9l4.6-14.55m3.85-12.15l-3.85 12.15h31.8l1.3-12.15H149.8m0 0l3.25-10.25h-27.1l-5.4 10.25h29.25m-35.7 12.15l6.45-12.15H91.3l-9 12.15h31.8m-22.8-12.15l7.55-10.25H71.7L62 283.45h29.3m256.9 26.7l-13.75-14.55h-31.8l10.7 14.55h34.85m-6.9 37.95h42.85l-18.65-19.7h-38.7l14.5 19.7m27.2 36.9h16.45v-16h-28.2l11.75 16m15.65-36.9l.8.85v-.85h-.8m-27.4 20.9l-15.45-20.9h-42.8l11 20.9h47.25m28.2-57.2l-1.9-1.65H348.2l17.3 18.25h19.45v-16.6m-18.7-16.2l-14.05-12.15h-29.25l11.5 12.15h31.8m18.7 0h-18.7l16.8 14.55h1.9V295.6m-3.5-12.15l3.5 2.55v-2.55h-3.5m-41.1-10.25l11.85 10.25h29.25l-14-10.25h-27.1z" />
                    <path
                        fill="#9A9186"
                        d="M385 229.7V210q-192.5-2.673-385 0v19.7q193.28 3.507 385 0z"
                    />
                </g>
                <g id="PlaInd037__Layer2_1_MEMBER_0_FILL">
                    <path
                        fill="#373B3F"
                        d="M56.1 322.5L85.15 285H56.1v37.5m105.75-85.3H150.4V285l11.45-37v-10.8m167.05 2.75v-2.75h-36.45V273.6l36.45 48.9v-82.55z"
                    />
                    <path
                        fill="#343A3F"
                        d="M46.15 239.95h9.95v-2.75h-9.95v2.75m282.75 0h9.95v-2.75h-9.95v2.75z"
                    />
                    <path d="M161.85 237.2V248h130.6v-10.8h-130.6z" />
                    <path
                        fill="#272B2E"
                        d="M85.15 285h65.25v-47.8H56.1V285h29.05m62-22.55V282h-87.5v-19.55h87.5m0-22.5v19.55h-87.5v-19.55h87.5m-30.8 11v-2.5h-25.3v2.5h25.3m0 22.75v-2.5h-25.3v2.5h25.3z"
                    />
                </g>
                <g id="PlaInd037__Layer1_0_FILL">
                    <path d="M4.3 283.45H0v3.25l4.3-3.25m13.5-58.4v10.9l4.9-2.65v-10.35l-4.9 2.1m11.8-15.1l-6.9 2.7v10.25l6.9-3.05v-9.9z" />
                    <path
                        fill="#292622"
                        d="M12.85 283.45H4.3L0 286.7v6.95l.2.5 12.65-10.7z"
                    />
                    <path
                        fill="#383427"
                        d="M29.6 233.85l-11.8 6.6v43l11.8-10.25v-39.35z"
                    />
                    <path
                        fill="#726A60"
                        d="M22.7 222.95v10.35l6.9-3.7v-9.75l-6.9 3.05v-10.25l-4.9 2v10.4l4.9-2.1z"
                    />
                    <path
                        fill="#850000"
                        d="M17.8 235.95v4.5l11.8-6.6v-4.25l-6.9 3.7-4.9 2.65m4.9-23.3l6.9-2.7V206l-11.8 4.65v4l4.9-2z"
                    />
                    <path
                        fill="#58523B"
                        d="M29.6 206H25l-12 4.65h4.8L29.6 206z"
                    />
                    <path fill="#100E0A" d="M4.3 15.5H0v267.95h4.3V15.5z" />
                    <path
                        fill="url(#PlaInd037__Gradient_2)"
                        d="M0 7.8l13 7.7v195.15L25 206V0H.2L0 .35V7.8z"
                    />
                    <path fill="#0B0B08" d="M4.3 15.5H13L0 7.8v7.7h4.3z" />
                    <path
                        fill="#201E17"
                        d="M13 15.5H4.3v267.95h13.5v-72.8H13V15.5z"
                    />
                </g>
                <g id="PlaInd037__Layer1_1_FILL">
                    <path
                        fill="#383427"
                        d="M355.4 273.15l11.8 10.25v-43l-11.8-6.6v39.35z"
                    />
                    <path
                        fill="#292622"
                        d="M385 293.6v-6.95l-4.3-3.25h-8.55l12.65 10.7.2-.5z"
                    />
                    <path d="M385 286.65v-3.25h-4.3l4.3 3.25m-29.6-76.75v9.9l6.9 3.1v-10.3l-6.9-2.7m11.8 26V225l-4.9-2.1v10.35l4.9 2.65z" />
                    <path
                        fill="#726A60"
                        d="M355.4 229.55l6.9 3.7V222.9l-6.9-3.1v9.75m11.8-4.55v-10.4l-4.9-2v10.3l4.9 2.1z"
                    />
                    <path
                        fill="#850000"
                        d="M367.2 214.6v-4l-11.8-4.65v3.95l6.9 2.7 4.9 2m0 25.8v-4.5l-4.9-2.65-6.9-3.7v4.25l11.8 6.6z"
                    />
                    <path
                        fill="#58523B"
                        d="M367.2 210.6h4.8l-12-4.65h-4.6l11.8 4.65z"
                    />
                    <path fill="#100E0A" d="M385 15.45h-4.3V283.4h4.3V15.45z" />
                    <path
                        fill="#201E17"
                        d="M380.7 15.45H372V210.6h-4.8v72.8h13.5V15.45z"
                    />
                    <path fill="#0B0B08" d="M385 15.45v-7.7l-13 7.7h13z" />
                    <path
                        fill="url(#PlaInd037__Gradient_3)"
                        d="M385 .3l-.2-.3H360v205.95l12 4.65V15.45l13-7.7V.3z"
                    />
                </g>
                <g id="PlaInd037__Layer1_2_MEMBER_1_FILL">
                    <path
                        fill="#6F7583"
                        d="M254.55 181.6l2.35-2.35v-25q17.05-1.6 34.7 0l2.2-2.2q-19.95-1.5-39.25 0v29.55z"
                    />
                    <path
                        fill="#232527"
                        d="M254.55 181.6q7.8.85 15.65.95 5 .2 9.95 0 6.85-.2 13.65-.95v-29.55l-2.2 2.2v25q-5.75.4-11.45.6-4.95.25-9.95.15-6.7-.15-13.3-.75l-2.35 2.35z"
                    />
                </g>
                <g id="PlaInd037__Layer1_2_MEMBER_2_FILL">
                    <path
                        fill="#232527"
                        d="M169.4 180.5l-2.35 2.35q7.8.85 15.65.95 5 .2 9.95 0 6.85-.2 13.65-.95V153.3l-2.2 2.2v25q-5.75.4-11.45.6-4.95.25-9.95.15-6.7-.15-13.3-.75z"
                    />
                    <path
                        fill="#6F7583"
                        d="M169.4 180.5v-25q17.05-1.6 34.7 0l2.2-2.2q-19.95-1.5-39.25 0v29.55l2.35-2.35z"
                    />
                </g>
                <g id="PlaInd037__Layer1_2_MEMBER_3_FILL">
                    <path
                        fill="#6F7583"
                        d="M147.05 122.5l3.45-3.5q-31.55-2.4-62.1 0v46.75l3.75-3.75v-39.5q26.95-2.5 54.9 0z"
                    />
                    <path
                        fill="#232527"
                        d="M150.5 119l-3.45 3.5V162q-9.1.75-18.1 1.15-7.85.2-15.65.1-10.75-.3-21.15-1.25l-3.75 3.75q12.45 1.35 24.9 1.7 7.8.1 15.65-.1 10.8-.4 21.55-1.6V119z"
                    />
                </g>
                <g id="PlaInd037__Layer1_2_MEMBER_4_FILL">
                    <path
                        fill="#232527"
                        d="M85.7 201.25h21.15v-3H85.7v3m38.4 2.6v-5.6h-5.25v5.6h5.25m11.9-5.6h-5.55v5.6H136v-5.6m11.2 5.6v-5.6h-5.6v5.6h5.6m-40.35-11.05v-5.5H85.7v5.5h21.15M79.7 179.65v2.7h78.55v-2.7H79.7z"
                    />
                    <path
                        fill="#545862"
                        d="M141.6 187.1v5.55h5.6v-5.55h-5.6m-5.6 5.55v-5.55h-5.55v5.55H136m-17.15-5.55v5.55h5.25v-5.55h-5.25z"
                    />
                </g>
                <g id="PlaInd037__Layer1_3_MEMBER_0_FILL">
                    <path
                        fill="#ADADAD"
                        d="M133.55 194.1l.35 2.15.1.05h15.1l-4.35-2.2h-11.2z"
                    />
                    <path
                        fill="#DBDBDB"
                        d="M132 194.1h12.75l4.35 2.2H134l-.1-.05v.05l2.2 13.7v.05l1.9 11.9h11.75l.05-.1 4.4-27.75h1.55v-2.45H132v2.45z"
                    />
                </g>
                <g id="PlaInd037__Layer1_3_MEMBER_0_MEMBER_0_FILL">
                    <path
                        fill="#DB0000"
                        d="M150.5 217.25l-14.4-7.2.85 5.4 12.85 6.4.7-4.6m-16.6-21v.05l.85 5.5 16.9 8.45.75-4.7-18.5-9.3m19.95.05h-4.7l4.35 2.2.35-2.2z"
                    />
                    <path
                        fill="#B10000"
                        d="M149.15 196.3h4.7l.35-2.2h-9.45l4.35 2.2h.05z"
                    />
                </g>
                <g id="PlaInd037__Layer1_5_FILL">
                    <path
                        fill="#807D6E"
                        d="M268.05 227.65l1.25 2.2 27.7-1.65-13.6-14.85-2.5.2 7.8 11.35-20.65 2.75z"
                    />
                    <path
                        fill="#B1AFA6"
                        d="M313.65 214.15q-.4-.25-1.15-.25-1.15 0-1.85.8-.15.15-.25.3-.4.2-1 .2-.85 0-1.1.1-1.05.4-.95 1.65.05 1.25-.8 1.7-.9.35-.9 1.4 0 .8.05.95.2.3 1.4 1.1.2.05.65 1.05.65.85 1.9.85.45 0 1-.2.6-.3.85-.3l.9.45q.85.45 2.05.45 1.7 0 2.1-.6.25-.35.45-.95 1.25 0 1.8-.75l.1-.2q.1-.15.2-.25.2-.3.2-1.15.05-.55.05-.75 0-.3-.45-.9-.45-.65-.65-.85-.2-.45-.15-.8 0-.1-.05-.2.05-.05.1-.2 0-.65-.05-.75-.1-.3-.8-.85-.55-.45-1.45-.3-1.05.1-1.7-.3-.3-.35-.5-.45m1.75 8.5q.1.05.15.05-.05.05-.1.15-.05-.15-.05-.2z"
                    />
                </g>
                <g id="PlaInd037__Layer1_6_FILL">
                    <path d="M452.9 150l24 48.05q12-6.55 22.05-20.1L452.9 150m10.45 63.5l-.35-3.25h-21.85l-.4 3.25h22.6M428.7 101.35q-14.15 6.35-22.85 19.8l46.35 28.4-23.5-48.2z" />
                    <path
                        fill="#737A80"
                        d="M423.85 196.25l28.4-46.35-48.2 23.5q6.35 14.15 19.8 22.85m56.8-93.1L452.7 149.2l48.05-24q-6.55-12-20.1-22.05z"
                    />
                    <path
                        fill="#272B2E"
                        d="M416.25 213.5v14.8h71.5v-14.8h-71.5m40.95-54.25h-10.3l-5.75 51H463l-5.8-51z"
                    />
                </g>
                <g id="PlaInd037__Layer1_6_MEMBER_0_FILL">
                    <path
                        fill="#4B5258"
                        d="M507.15 148.3q-.6-21.7-16.05-37.1-16.1-16.1-38.85-16.1-22.8 0-38.85 16.1-15.45 15.4-16 37.1h-.05q-.05 1.2-.1 2.3h.1q.2 22.4 16.05 38.25 15.5 15.5 37.25 16.05h2.3q22.3-.25 38.15-16.05 14.6-14.6 15.95-34.8-.1.7-.2 1.55l.3-7.3m-11.05 0h-6.6q-.7-14.15-10.8-24.35h-.05q-10.7-10.65-25.7-10.9v-6.55q17.7.25 30.3 12.85 12.15 12.05 12.85 28.95m8.75 0h-6.45q-.7-17.85-13.55-30.6h.05q-13.25-13.25-31.95-13.5v-6.85q21.35.25 36.5 15.45 14.8 14.8 15.4 35.5m-6.45 2.3h6.45q-.2 21.4-15.4 36.65-15.15 15.15-36.5 15.4v-6.2q18.7-.25 31.95-13.45 13.4-13.45 13.5-32.4m-8.85 0h6.55q-.1 17.95-12.85 30.75-12.6 12.55-30.3 12.8v-6.5q15.05-.25 25.75-10.9 10.75-10.8 10.85-26.15m-36.6-28.9v-6.35q14.05.25 24.1 10.2v.05q9.45 9.5 10.15 22.7h-6.7q-.6-10.6-8.25-18.25-8.05-8.05-19.3-8.35m-2.3-15.15v6.55q-14.45.5-24.75 10.85-10.2 10.15-10.9 24.35h-6.5q.65-16.9 12.8-28.95 12.2-12.3 29.35-12.8m0 8.85v6.3q-10.95.45-18.75 8.35-7.7 7.65-8.3 18.25h-6.3q.7-13.2 10.25-22.7 9.65-9.7 23.1-10.2m2.3 15.4V124q10.3.25 17.65 7.65v.05q7 6.95 7.6 16.6h-6.45q-.65-6.85-5.6-11.8h-.05q-5.5-5.45-13.15-5.7m-2.3-6.8v6.85q-7.1.5-12.25 5.65-4.95 5-5.6 11.8h-6.9q.6-9.65 7.65-16.6v-.05q7.15-7.2 17.1-7.65m-.8 22.95q1.1-1.05 2.65-1.05 1.55 0 2.6 1.05 1.1 1.1 1.1 2.65 0 1.55-1.1 2.6-1.05 1.1-2.6 1.1t-2.65-1.1q-1.05-1.05-1.05-2.6t1.05-2.65m13.65 1.35q-.55-3.5-3.2-6.15-3.1-3.1-7.35-3.3v-5.75q6.75.25 11.55 5.05 4.3 4.3 4.95 10.15h-5.95m-12.85-15.15v5.75q-3.7.45-6.5 3.25-2.65 2.65-3.2 6.15h-5.85q.65-5.85 4.9-10.15l.05-.05q4.5-4.45 10.6-4.95m-31-15.45q-12.8 12.75-13.45 30.6h-6.55q.55-20.7 15.4-35.5 14.85-14.9 35.6-15.4v6.85q-18.1.5-31 13.45m21.15 32.9q.15 4.5 3.35 7.7 2.8 2.8 6.5 3.25v6.05q-6.1-.5-10.6-5-4.95-4.95-5.05-12h5.8m-2.4 13.6v.05q5.15 5.15 12.25 5.65v6.45q-9.95-.5-17.1-7.65-7.55-7.5-7.7-18.1h6.85q.1 7.95 5.7 13.6m-21.15-13.6h6.3q.15 11.55 8.35 19.75 7.8 7.8 18.75 8.3v6.7q-13.45-.55-23.1-10.25h-.05q-10.15-10.15-10.25-24.5m-8.8 0h6.5q.1 15.3 10.95 26.1v.05q10.35 10.35 24.75 10.9v6.5q-17.15-.55-29.35-12.8-12.75-12.75-12.85-30.75m11.2 32.35v.05q12.9 12.9 31 13.45v6.2q-20.75-.55-35.6-15.4Q399.8 172 399.6 150.6h6.55q.1 18.95 13.5 32.35m52.6-12.6q8.15-8.2 8.3-19.75h6.7q-.1 14.35-10.2 24.5-10.05 10-24.1 10.25v-6.7q11.25-.3 19.3-8.3m-.4-19.75h6.4q-.15 10.6-7.65 18.1-7.35 7.3-17.65 7.65v-6.4q7.7-.25 13.2-5.7 5.6-5.65 5.7-13.65m-11.55 7.7q3.2-3.2 3.35-7.7h5.9q-.1 7-5.05 12-4.85 4.8-11.55 5.05v-6q4.25-.25 7.35-3.35z"
                    />
                    <path
                        fill="#737A80"
                        d="M452.5 145.9q-1.55 0-2.65 1.05-1.05 1.1-1.05 2.65 0 1.55 1.05 2.6 1.1 1.1 2.65 1.1 1.55 0 2.6-1.1 1.1-1.05 1.1-2.6t-1.1-2.65q-1.05-1.05-2.6-1.05z"
                    />
                </g>
                <g id="PlaInd037__Layer1_7_FILL">
                    <path d="M317.4 237.2h-36.6v70h36.6v-70m-38 0h-12.8v46l12.8 24v-70z" />
                    <path fill="#212427" d="M280.8 237.2h-1.4v70h1.4v-70z" />
                </g>
                <path
                    fill="#665F56"
                    d="M385 385V0H0v385h385z"
                    id="PlaInd037__Layer4_0_FILL"
                />
                <path
                    d="M177.3 219.85h-9.85v9.85h9.85v-9.85m9.85 0V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85H197v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210H197v9.85h9.85m19.7 0V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210h-9.85v9.85h9.85m19.7 0V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m9.85 0V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m9.85 0V210h-9.85v9.85h9.85m10.7 0h-10.7v9.85h10.7v-9.85m-306.2 0V210H0v9.85h9.85m9.85 0H9.85v9.85h9.85v-9.85m9.85 0V210H19.7v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210H39.4v9.85h9.85m19.7 0V210H59.1v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210H78.8v9.85h9.85m19.7 0V210H98.5v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210h-9.85v9.85h9.85m19.7 0V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m0-9.85v9.85h9.85V210h-9.85m168.3 9.85V210h-9.85v9.85h9.85m9.85 0h-9.85v9.85h9.85v-9.85m19.7 0h-9.85v9.85h9.85v-9.85m-9.85 0V210h-9.85v9.85h9.85m29.55 0h-9.85v9.85h9.85v-9.85m-9.85 0V210h-9.85v9.85h9.85m19.7 0V210h-9.85v9.85H385z"
                    id="PlaInd037__Layer3_1_FILL"
                />
                <path
                    fill="#B40000"
                    d="M385 210.25v-4H0v4h385m0 23.2v-4H0v4h385z"
                    id="PlaInd037__Layer3_2_FILL"
                />
                <path
                    fillOpacity={0.6}
                    d="M336.85 273v-9h-3.15v-27.25H50.5V273H0v15.95h50.5v33.55h286.25v-33.55H385V273h-48.15z"
                    id="PlaInd037__Layer2_0_FILL"
                />
                <path
                    fill="#4B5258"
                    d="M338.85 237.2h6.85V227q-153.175-6.21-306.35 0v10.2h6.8v85.3h9.95q12.06-21.522 29.05-37.5 32.625-3.123 65.25 0 2.36-22.238 11.45-37-3.533-5.4 0-10.8h130.6q5.384 18.2 0 36.4 20.54 21.143 36.45 48.9h9.95v-85.3z"
                    id="PlaInd037__Layer2_1_FILL"
                />
                <path
                    fill="#5C646B"
                    d="M80.9 205.75L39.35 227H345.7l-41.6-21.25H80.9z"
                    id="PlaInd037__Layer2_1_MEMBER_1_FILL"
                />
                <path
                    d="M161.85 154.35v56.3h49.45v-56.3h-49.45m-81.6-42.05v61.35h33.05v6q3.72 1.43 7.2 1.6-20.387-.058-40.8 1.1v31.1h78.55v-31.1q-18.1-1.027-36.2-1.1 3.562-.128 6.9-1.6v-6h29.55V112.3H80.25m216.3 36H247.1v62.1h49.45v-62.1z"
                    id="PlaInd037__Layer1_2_FILL"
                />
                <path
                    fill="#232527"
                    d="M167.15 205.65h3.3v-3.55h-3.3v3.55m8.55 0v-3.55h-3.6v3.55h3.6m1.65 0h3.55v-3.55h-3.55v3.55m8.8-3.55h-3.6v3.55h3.6v-3.55m5.2 0h-3.55v3.55h3.55v-3.55m5.25 0H193v3.55h3.6v-3.55m5.2 0h-3.55v3.55h3.55v-3.55m5.25 3.55v-3.55h-3.55v3.55h3.55m0-8.8h-3.55v3.55h3.55v-3.55m-5.25 0h-3.55v3.55h3.55v-3.55m-5.2 0H193v3.55h3.6v-3.55m-5.25 0h-3.55v3.55h3.55v-3.55m-5.2 0h-3.6v3.55h3.6v-3.55m-10.45 0h-3.6v3.55h3.6v-3.55m5.2 0h-3.55v3.55h3.55v-3.55m-10.45 0h-3.3v3.55h3.3v-3.55z"
                    id="PlaInd037__Layer1_2_MEMBER_0_FILL"
                />
                <path
                    fill="#232527"
                    d="M260.7 201.85h-3.6v3.55h3.6v-3.55m-5.25 3.55v-3.55h-3.3v3.55h3.3m12.1 0h3.6v-3.55h-3.6v3.55m-1.65 0v-3.55h-3.55v3.55h3.55m10.45 0v-3.55h-3.55v3.55h3.55m5.25-3.55H278v3.55h3.6v-3.55m5.2 3.55v-3.55h-3.55v3.55h3.55m5.25-3.55h-3.55v3.55h3.55v-3.55m-5.25-5.25h-3.55v3.55h3.55v-3.55m5.25 0h-3.55v3.55h3.55v-3.55m-3.55-5.2v3.55h3.55v-3.55h-3.55m-22.6 5.2h-3.55v3.55h3.55v-3.55m10.45 0h-3.55v3.55h3.55v-3.55m5.25 0H278v3.55h3.6v-3.55m1.65-5.2v3.55h3.55v-3.55h-3.55m-5.25 3.55h3.6v-3.55H278v3.55m-6.85 1.65h-3.6v3.55h3.6v-3.55m0-1.65v-3.55h-3.6v3.55h3.6m1.65-3.55v3.55h3.55v-3.55h-3.55m-17.35 5.2h-3.3v3.55h3.3v-3.55m6.9-5.2v3.55h3.55v-3.55h-3.55m-1.65 5.2h-3.6v3.55h3.6v-3.55m-3.6-1.65h3.6v-3.55h-3.6v3.55m-4.95-3.55v3.55h3.3v-3.55h-3.3z"
                    id="PlaInd037__Layer1_2_MEMBER_5_FILL"
                />
                <path
                    fill="#ADADAD"
                    d="M145.9 191.65v-14.6l9.15 6.05 1.1-1.85-9.3-6.15q-3.2-1.05-3.9 1.6-.05.15-.05.25v14.7q1.785 2.755 3 0z"
                    id="PlaInd037__Layer1_3_FILL"
                />
                <path
                    fill="#B1AFA6"
                    d="M121.85 216.1q.1-.1.15-.2.1-.15.2-.25.2-.35.2-1.25.05-.6.05-.85 0-.3-.45-.95-.5-.7-.7-.95-.25-.45-.2-.85 0-.1-.05-.2.05-.1.1-.25 0-.7-.05-.8-.1-.35-.85-.95-.6-.45-1.6-.3-1.1.1-1.85-.35-.3-.35-.55-.5-.4-.25-1.25-.25-1.25 0-2 .85-.15.2-.25.35-.45.2-1.1.2-.95 0-1.2.1-1.15.45-1.05 1.8.05 1.4-.85 1.85-1 .4-1 1.55 0 .85.1 1 .2.35 1.5 1.2.2.1.7 1.15.7.95 2.05.95.5 0 1.1-.25.65-.3.95-.3l.95.5q.95.5 2.25.5 1.85 0 2.3-.7.25-.35.45-1 1.35 0 1.95-.85m-3.5.65l-.1.2q-.05-.2-.05-.25.1.05.15.05z"
                    id="PlaInd037__Layer1_4_FILL"
                />
                <path
                    fill="#B1AFA6"
                    d="M272.4 206.85l-22.85 1.6 8.75 14.9 27.7-1.65-13.6-14.85z"
                    id="PlaInd037__Layer1_5_MEMBER_0_FILL"
                />
                <path
                    fill="#212427"
                    d="M287.75 275.75l-.05.05q-4.404 4.483-4.4 10.75-.007 6.23 4.4 10.65 4.468 4.456 10.75 4.45 6.267-.005 10.65-4.45 4.498-4.436 4.5-10.65.008-6.28-4.5-10.8-4.366-4.354-10.65-4.35-6.27-.003-10.7 4.35m1.6 1.65q3.787-3.698 9.1-3.7 5.316.004 9 3.7 3.842 3.83 3.85 9.15.002 5.269-3.8 9l-.05.05q-3.685 3.755-9 3.75-5.318-.006-9.1-3.8-3.743-3.73-3.75-9 .004-5.315 3.75-9.15m13.15 14.55q0-1.65-1.15-2.8t-2.8-1.15q-1.65 0-2.8 1.15t-1.15 2.8q0 1.65 1.15 2.8t2.8 1.15q1.65 0 2.8-1.15t1.15-2.8m4.6-44.85q-3.568-3.556-8.65-3.55-5.015-.006-8.65 3.55l-.05.05q-3.501 3.58-3.5 8.65-.003 5.017 3.5 8.6h.05q3.635 3.606 8.65 3.6 5.082.006 8.65-3.6 3.607-3.57 3.6-8.6.006-5.082-3.6-8.7m-1.65 1.65q2.944 2.932 2.95 7.05-.008 4.07-2.95 6.95-2.882 2.944-7 2.95-4.068-.006-7.05-2.9v-.05q-2.847-2.885-2.85-6.95.001-4.113 2.85-7.05 2.982-2.894 7.05-2.9 4.118.006 7 2.9m-7 8.05q-1.3 0-2.2.9-.85.9-.85 2.15 0 1.3.85 2.2.9.85 2.2.85 1.25 0 2.15-.85.9-.9.9-2.2 0-1.25-.9-2.15-.9-.9-2.15-.9z"
                    id="PlaInd037__Layer1_7_MEMBER_0_FILL"
                />
                <linearGradient
                    id="PlaInd037__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={192.5}
                    y1={160.8}
                    x2={192.5}
                    y2={3.6}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#46412F" />
                    <stop offset="100%" stopColor="#252219" />
                </linearGradient>
                <linearGradient
                    id="PlaInd037__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    x1={10.9}
                    y1={134.4}
                    x2={10.9}
                    y2={5.6}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#383427" />
                    <stop offset="100%" stopColor="#171510" />
                </linearGradient>
                <linearGradient
                    id="PlaInd037__Gradient_3"
                    gradientUnits="userSpaceOnUse"
                    x1={374.1}
                    y1={108.388}
                    x2={374.1}
                    y2={6.813}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#383427" />
                    <stop offset="100%" stopColor="#171510" />
                </linearGradient>
            </defs>
            <use xlinkHref="#PlaInd037__Layer4_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer4_1_FILL" />
            <use xlinkHref="#PlaInd037__Layer3_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer3_1_FILL" />
            <use xlinkHref="#PlaInd037__Layer3_2_FILL" />
            <use xlinkHref="#PlaInd037__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer2_1_FILL" />
            <use xlinkHref="#PlaInd037__Layer2_1_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer2_1_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_1_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_2_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_2_MEMBER_0_FILL" />
            <use
                xlinkHref="#PlaInd037__Layer1_2_MEMBER_1_FILL"
                transform="translate(-1.75 .5)"
            />
            <use
                xlinkHref="#PlaInd037__Layer1_2_MEMBER_2_FILL"
                transform="translate(0 5.7)"
            />
            <use xlinkHref="#PlaInd037__Layer1_2_MEMBER_3_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_2_MEMBER_4_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_2_MEMBER_5_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_3_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_3_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_3_MEMBER_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_4_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_5_FILL" />
            <use
                xlinkHref="#PlaInd037__Layer1_5_MEMBER_0_FILL"
                transform="translate(6.5 4.5)"
            />
            <use
                xlinkHref="#PlaInd037__Layer1_6_FILL"
                transform="matrix(.67242 0 0 .67242 -86 63.95)"
            />
            <use
                xlinkHref="#PlaInd037__Layer1_6_MEMBER_0_FILL"
                transform="matrix(.6724 0 0 .6724 -85.8 63.85)"
            />
            <use xlinkHref="#PlaInd037__Layer1_7_FILL" />
            <use xlinkHref="#PlaInd037__Layer1_7_MEMBER_0_FILL" />
        </g></g>
    )
}
export default PlaInd037
